<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <div class="sidebar-search-container" v-if="!isBigBackend && !isCollapse">
      <el-input
        v-model="searchText"
        prefix-icon="el-icon-search"
        @input="searchInput"
      >
      </el-input>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper" ref="menuContainer">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.themeColor"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          ref="sidebar-item"
          v-for="route in filteredMenuList"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :search-text="searchText"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { constantRoutes } from '@/router/index';
  import Logo from './Logo';
  import SidebarItem from './SidebarItem';
  import variables from '@/styles/variables';
  import { debounce } from '@/utils';
  import { getPlateForm } from '@/utils/auth';

  export default {
    components: { SidebarItem, Logo },
    data() {
      return {
        constantRoutes,
        searchText: '',
        menuContainer: null,
        expandHandler: null
      };
    },
    mounted() {
      this.expandHandler = debounce(this.expandAll.bind(this), 200);
    },
    computed: {
      ...mapGetters([
        // 'permission_routes',
        'sidebar'
      ]),
      isBigBackend() {
        return getPlateForm();
      },
      activeMenu() {
        const route = this.$route;
        const { meta, path } = route;
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu;
        }
        return path;
      },
      showLogo() {
        return this.$store.state.settings.sidebarLogo;
      },
      variables() {
        return variables;
      },
      isCollapse() {
        return !this.sidebar.opened;
      },
      filteredMenuList() {
        if (!this.searchText.trim()) {
          return this.constantRoutes;
        }
        return this.filterList(this.constantRoutes, this.searchText);
      }
    },
    methods: {
      filterList(list, searchText) {
        const search = (nodes) => {
          return nodes
            .filter((node) => {
              if (!node.meta) return false;
              if (!this.checkPermission(node) || !node.meta.title) {
                return false;
              }
              // 标题匹配或子节点匹配
              const titleMatches = node.meta.title.includes(searchText);
              const hasMatchingChildren =
                node.children && node.children.length > 0;
              return titleMatches || hasMatchingChildren;
            })
            .map((node) => {
              // 创建新对象，不修改原对象
              const newNode = { ...node };
              if (node.children && node.children.length > 0) {
                const filteredChildren = search(node.children);
                // 只有当标题匹配或有匹配的子节点时才保留
                if (
                  node.meta.title.includes(searchText) ||
                  filteredChildren.length > 0
                ) {
                  newNode.children = filteredChildren;
                  return newNode;
                }
                return null;
              }
              return newNode;
            })
            .filter((node) => node !== null);
        };
        return search(list);
      },
      checkPermission(item) {
        if (item.hidden === true) {
          return false;
        }
        const menuIdRightList = this.$store.state.app.permissionCodes;
        if (item.meta?.menuId) {
          return menuIdRightList.includes(item.meta.menuId);
        }
        return false;
      },
      expandAll() {
        const mc = this.$refs['menuContainer'];
        if (!mc) return;
        const list = mc.$el.querySelectorAll('li[role="menuitem"]');
        list.forEach((menuItem) => {
          if (
            !menuItem.getAttribute('aria-expanded') ||
            menuItem.getAttribute('aria-expanded') !== 'true'
          ) {
            const firstChild = menuItem.firstElementChild;
            if (
              firstChild &&
              typeof firstChild.className === 'string' &&
              firstChild.className.includes('el-submenu__title')
            ) {
              firstChild.click();
            }
          }
        });
      },
      searchInput() {
        this.expandHandler();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .sidebar-search-container {
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 16px;
  }
</style>
